import { useState } from 'react';

import { PHONES_ONLY_BREAKPOINT } from 'src/constants/screen.constants';
import { useEventListener } from 'src/hooks/use-event-listener';
import { getBrowserMediaQueryWidth } from 'src/utils/browser.utils';

export const useMobileLayoutCheck = () => {
  const initialIsMobileLayout =
    getBrowserMediaQueryWidth() < PHONES_ONLY_BREAKPOINT;

  const [isMobileLayout, setIsMobileLayout] = useState(initialIsMobileLayout);

  useEventListener('resize', () => {
    const screenWidth = getBrowserMediaQueryWidth();

    setIsMobileLayout(screenWidth < PHONES_ONLY_BREAKPOINT);
  });

  return isMobileLayout;
};
